<template>
  <b-row>
    <b-col>
      <h6 class="compo-heading">{{ $t('5003.grouping.title') }}</h6>
    </b-col>
  </b-row>
  <div class="details-card">
    <b-row>
      <b-col lg="12" md="12" sm="12" cols="12" class="addcircle_field">
        <div class="field">
          <CustomDropDown v-model="Grouping.ItemTypeId" :items="ItemCategoryDropdown.ItemCategoryoption"
            @update:modelValue="ItemCategoryOnChange" :label="$t('5003.grouping.category')" name="Category"
            id="Category" :rules="{ required: true }" :required-icon="true" :tabindex="9" />
        </div>
        <span class="add_circle" @click="FunctionRights(EntityIds.Category, 'Category')"><i
            class="pi pi-plus"></i></span>
      </b-col>
      <b-col lg="12" md="12" sm="12" cols="12" class="addcircle_field">
        <div class="field">
          <CustomDropDown v-model="Grouping.ItemGroupId" :items="ItemGroupDropdown.ItemGroupoption"
            @update:modelValue="ItemGroupOnChange" :label="$t('5003.grouping.group')" name="Item Group" id="Item Group"
            :rules="{ required: true }" :required-icon="true" :tabindex="10" />
        </div>
        <span class="add_circle" @click="FunctionRights(EntityIds.SubCategory, 'SubCategory')"><i
            class="pi pi-plus"></i></span>
      </b-col>
      <b-col lg="12" md="12" sm="12" cols="12" class="addcircle_field">
        <div class="field">
          <CustomDropDown v-model="Grouping.SubGroupId" :items="ItemSubGroupDropdown.ItemSubGroupoption"
            @update:modelValue="ItemSubGroupOnChange" :label="$t('5003.grouping.subgroup')" name="Item Sub Group"
            id="Item Sub Group" :rules="{ required: true }" :required-icon="true" :tabindex="11" />
        </div>
        <span class="add_circle" @click="FunctionRights(EntityIds.SubGroup, 'SubGroup')"><i
            class="pi pi-plus"></i></span>
      </b-col>
      <b-col lg="12" md="12" sm="12" cols="12" class="addcircle_field">
        <div class="field">
          <CustomDropDown v-model="Grouping.AccountHeadId" :items="ItemCategoryDropdown.AccountHeadOption"
            @update:modelValue="ItemAccountHeadOnChange" :label="$t('5003.grouping.AccountHead')" name="AccountHead"
            id="AccountHead" :rules="{ required: false }" :required-icon="false" :tabindex="12" />
        </div>
        <span class="add_circle" @click="FunctionRights(EntityIds.AccountHead, 'AccountHead')"><i
            class="pi pi-plus"></i></span>
      </b-col>
      <b-col lg="12" md="12" sm="12" cols="12">
        <div class="field">
          <CustomMultiSelect v-model="ItemConfiguration.Brand" :items="BrandDropdown.ItemBrandoption"
            @update:modelValue="ItemBrandOnChange" :label="$t('5003.grouping.Brand')" name="Brand" id="Brand"
            :rules="{ required: false }" :required-icon="false" :tabindex="13" />
        </div>
      </b-col>
      <b-col lg="12" md="12" sm="12" cols="12">
        <div class="field">
          <CustomMultiSelect v-model="ItemConfiguration.ModelNumber" :items="ModelNumberDropdown.ItemModelNumberoption"
            @update:modelValue="ItemModelNumberOnChange" :label="$t('5003.grouping.ModelNumber')" name="Model Number"
            id="Model Number" :rules="{ required: false }" :required-icon="false" :tabindex="14" />
        </div>
      </b-col>
      <b-col lg="12" md="12" sm="12" cols="12" class="addcircle_field">
        <div class="field">
          <CustomMultiSelect v-model="ItemConfiguration.Size" :items="SizeDropdown.ItemSizeoption"
            @update:modelValue="ItemSizeOnChange" :label="$t('5003.grouping.Size')" name="Size" id="Size"
            :rules="{ required: false }" :required-icon="false" :tabindex="15" />
        </div>
        <span class="add_circle" @click="FunctionRights(EntityIds.ItemConfiguration, 'ItemConfiguration')"><i
            class="pi pi-plus"></i></span>
      </b-col>
      <b-col lg="12" md="12" sm="12" cols="12">
        <div class="field">
          <TextField v-model="Grouping.ColdChain" @change="" :label="$t('5003.grouping.ColdChain')" name="ColdChain"
            id="ColdChain" :rules="{ required: false }" :tabindex="16" />
        </div>
      </b-col>
    </b-row>
  </div>
  <CategoryCreation v-if="DialogShow.Category" @load="LoadItemCategory(), (DialogShow.Category = false)"
    @close="DialogShow.Category = false" @loaderhide="loading = false" @loadershow="loading = true"
    :OperationID="ObjOperationId" :EntityId="EntityIds.Category" />
  <GroupCreation v-model:trigger="DialogShow.SubCategory" v-if="DialogShow.SubCategory"
    @load="LoadItemGroup(), (DialogShow.SubCategory = false)" @close="DialogShow.SubCategory = false"
    @loaderhide="loading = false" @loadershow="loading = true" :OperationID="ObjOperationId"
    :EntityId="EntityIds.SubCategory" />
  <SubGroupCreation v-model:trigger="DialogShow.SubGroup" v-if="DialogShow.SubGroup"
    @load="LoadItemSubGroup(), (DialogShow.SubGroup = false)" @close="DialogShow.SubGroup = false"
    @loaderhide="loading = false" @loadershow="loading = true" :OperationID="ObjOperationId"
    :EntityId="EntityIds.SubGroup" />
  <ItemConfiguration v-model:trigger="DialogShow.ItemConfiguration" v-if="DialogShow.ItemConfiguration"
    @load="LoadItemConfigurations(), (DialogShow.ItemConfiguration = false)"
    @close="DialogShow.ItemConfiguration = false" @loaderhide="loading = false" @loadershow="loading = true"
    :OperationID="ObjOperationId" :EntityId="EntityIds.ItemConfiguration" />
  <accountHeadCreation v-model:trigger="DialogShow.AccountHead" v-if="DialogShow.AccountHead"
    @load="LoadAccountHead(), (DialogShow.AccountHead = false)" @close="DialogShow.AccountHead = false"
    @loaderhide="loading = false" @loadershow="loading = true" :OperationID="ObjOperationId"
    :EntityId="EntityIds.AccountHead" />
  <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, reactive, toRefs, watch, onMounted } from "vue";
import service from "../../Service/ItemMasService";
import ItemConfigurationService from "../../Service/ItemConfiguration";
import CustomDropDown from "../../../../components/FormComponents/Dropdown.vue";
import CustomMultiSelect from "../../../../components/FormComponents/MultiSelectDropdown.vue";
import TextField from "../../../../components/FormComponents/TextInput.vue";
import AccountHeadService from "../../../../modules/Inventory/Service/AccountHeadService";
import CategoryCreation from "../../../../modules/Inventory/pages/Masters/ItemCategory/CategoryMaster/CategoryCreation.vue";
import GroupCreation from "../../../../modules/Inventory/pages/Masters/ItemCategory/GroupMaster/GroupCreation.vue";
import SubGroupCreation from "../../../../modules/Inventory/pages/Masters/ItemCategory/SubGroupMaster/SubGroupCreation.vue";
import MastersService from "../../../../modules/Inventory/Service/MastersService";
import { checkPermission } from "../../../../modules/Inventory/Service/AccessControl";
import { useToast } from "primevue/usetoast";
import ItemConfiguration from "../../../../modules/Inventory/pages/Masters/Items/ItemConfiguration/ItemConfigCreation.vue";
import accountHeadCreation from "../../../../modules/Inventory/pages/Masters/Items/AccountHead/accountHeadCreation.vue";
export default defineComponent({
  components: {
    CustomDropDown,
    CustomMultiSelect,
    TextField,
    CategoryCreation,
    GroupCreation,
    SubGroupCreation,
    ItemConfiguration,
    accountHeadCreation
  },

  props: {
    modelValue: Object,
    propsItemConfig: {
      type: Object,
      default: {},
    },
  },

  setup(props, { emit }) {
    let session: any = localStorage.getItem("UsersData");
    let ProductId = ref();
    let loading = ref(false);
    const toast = useToast();
    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);

    let Grouping = reactive({
      ItemTypeId: ref(),
      ItemGroupId: ref(),
      SubGroupId: ref(),
      Brand: "",
      ModelNumber: "",
      Size: "",
      ColdChain: "",
      AccountHeadId: ref()
    });

    const ItemConfiguration = ref({
      Brand: ref(),
      ModelNumber: ref(),
      Size: ref(),
    });
    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }
    let Rights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });
    const copyRights = JSON.parse(JSON.stringify(Rights.value));
    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });
    const copyObjOperationId = JSON.parse(JSON.stringify(ObjOperationId.value));
    let DialogShow = ref({
      Category: false,
      SubCategory: false,
      SubGroup: false,
      ItemConfiguration: false,
      AccountHead: false
    })
    let EntityIds = ref({
      Category: 106,
      SubCategory: 107,
      SubGroup: 108,
      ItemConfiguration: 317,
      AccountHead: 328
    })

    onMounted(() => {

      debugger;

      LoadItemCategory();
      LoadItemConfigurations();

      Object.assign(Grouping, props.modelValue);
      input();
      LoadAccountHead();

    });

    watch(props, (newValue: any) => {

      if (newValue.modelValue["ItemTypeId"]) {

        LoadItemGroup()
        LoadItemSubGroup()
        Object.assign(Grouping, props.modelValue);
        input();

      }

      // ItemConfiguration.value.Brand = newValue.propsItemConfig.Brand.split(
      //   ","
      // ).map((item) => Number(item));

      // ItemConfiguration.value.ModelNumber =
      //   newValue.propsItemConfig.ModelNumber.split(",").map((item) =>
      //     Number(item)
      //   );

      // ItemConfiguration.value.Size = newValue.propsItemConfig.Size.split(
      //   ","
      // ).map((item) => Number(item));

      ItemConfiguration.value.Brand =
        newValue.propsItemConfig.Brand.length == 0
          ? null
          : newValue.propsItemConfig.Brand.split(",").map((item) =>
            Number(item)
          );

      ItemConfiguration.value.ModelNumber =
        newValue.propsItemConfig.ModelNumber.length == 0
          ? null
          : newValue.propsItemConfig.ModelNumber.split(",").map((item) =>
            Number(item)
          );

      ItemConfiguration.value.Size =
        newValue.propsItemConfig.Size.length == 0
          ? null
          : newValue.propsItemConfig.Size.split(",").map((item) =>
            Number(item)
          );
    });

    function input() {
      emit("update:modelValue", Grouping);
      emit("ProductId", ProductId);
    }

    //Load Manufactures
    const ItemCategoryDropdown = ref({
      ItemCategoryid: null,
      ItemCategoryoption: [],
      AccountHeadOption: []
    });

    async function LoadItemCategory() {
      debugger;
      try {
        const response = await service.ItemCategory();

        ItemCategoryDropdown.value.ItemCategoryoption = response["result"]
          .filter(
            (f) =>
              f.Status == true &&
              f.HospitalId == HospitalId
          )
          .map((item) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });
      } catch (error) {
        alert(error);
      }
      input();
    }

    //Load Item Group
    const ItemGroupDropdown = ref({
      ItemGroupid: null,
      ItemGroupoption: [],
    });

    async function LoadItemGroup() {
      debugger;
      try {
        const response = await service.ItemGroup();

        ItemGroupDropdown.value.ItemGroupoption = response["result"]
          .filter(
            (f) =>
              f.Status == true &&
              f.HospitalId == HospitalId &&
              f.ProductTypeId == Grouping.ItemTypeId
          )
          .map((item) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });
      } catch (error) {
        alert(error);
      }
      input();
    }

    //Load Item SubGroup
    const ItemSubGroupDropdown = ref({
      ItemSubGroupid: null,
      ItemSubGroupoption: [],
    });

    async function LoadItemSubGroup() {
      debugger;
      try {
        const response = await service.ItemSubGroup();

        ItemSubGroupDropdown.value.ItemSubGroupoption = response["result"]
          .filter(
            (f) =>
              f.IsActive == true &&
              f.HospitalId == HospitalId &&
              f.GroupId == Grouping.ItemGroupId
          )
          .map((item) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });
      } catch (error) {
        alert(error);
      }
      input();
    }

    //Item Category On Change
    const ItemCategoryOnChange = (value: any, option: Selection) => {
      debugger;
      let selectedOption: any =
        ItemCategoryDropdown.value.ItemCategoryoption.find(
          (item) => item["Id"] === value
        );
      if (selectedOption) {
        ProductId.value =
          selectedOption["Prefix"] + String(selectedOption["CurrentValue"]);
      }
      Grouping.ItemTypeId = value;
      Grouping.ItemGroupId = ref();
      Grouping.SubGroupId = ref();
      LoadItemGroup();
      input();
    };

    //Item Group On Change
    const ItemGroupOnChange = (value: any, option: Selection) => {
      debugger;
      Grouping.ItemGroupId = value;
      LoadItemSubGroup();
    };

    //Item SubGroup On Change
    const ItemSubGroupOnChange = (value: any, option: Selection) => {
      debugger;
      Grouping.SubGroupId = value;
    };

    //Load Item Configuration
    const BrandDropdown = ref({
      ItemItemBrandid: null,
      ItemBrandoption: [],
    });

    const ModelNumberDropdown = ref({
      ItemItemModelNumberid: null,
      ItemModelNumberoption: [],
    });

    const SizeDropdown = ref({
      ItemItemSizeid: null,
      ItemSizeoption: [],
    });

    async function LoadItemConfigurations() {
      debugger;
      try {
        const response = await ItemConfigurationService.List();

        BrandDropdown.value.ItemBrandoption = response["result"]
          .filter(
            (f) =>
              f.IsActive == true &&
              f.HospitalId == HospitalId &&
              f.ICTypeId == 1
          )
          .map((item) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });

        ModelNumberDropdown.value.ItemModelNumberoption = response["result"]
          .filter(
            (f) =>
              f.IsActive == true &&
              f.HospitalId == HospitalId &&
              f.ICTypeId == 2
          )
          .map((item) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });

        SizeDropdown.value.ItemSizeoption = response["result"]
          .filter(
            (f) =>
              f.IsActive == true &&
              f.HospitalId == HospitalId &&
              f.ICTypeId == 3
          )
          .map((item) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });
      } catch (error) {
        alert(error);
      }
      input();
    }

    //Item Brand On Change
    const ItemBrandOnChange = (value: any, option: Selection) => {
      debugger;

      if (value != null) {
        Grouping.Brand = value.join(",");
      }
    };

    //Item Model Number On Change
    const ItemModelNumberOnChange = (value: any, option: Selection) => {
      debugger;
      if (value != null) {
        Grouping.ModelNumber = value.join(",");
      }
    };

    //Item Size On Change
    const ItemSizeOnChange = (value: any, option: Selection) => {
      debugger;
      if (value != null) {
        Grouping.Size = value.join(",");
      }
    };
    //Load Account Head
    async function LoadAccountHead() {
      debugger;
      try {
        const response = await AccountHeadService.getdata(HospitalId);

        ItemCategoryDropdown.value.AccountHeadOption = response["result"]
          .filter(
            (f) =>
              f.IsActive == true
          )
          .map((item) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });
      } catch (error) {
        alert(error);
      }
      input()
    }
    //Item SubGroup On Change
    const ItemAccountHeadOnChange = (value: any, option: Selection) => {
      debugger;
      Grouping.AccountHeadId = value;
    };

    async function FunctionRights(EntityId, FieldType) {
      debugger;
      Object.assign(Rights.value, copyRights);
      Object.assign(ObjOperationId.value, copyObjOperationId);
      const response = await MastersService.CheckMenuRights(
        EntityId,
        rolesData.RoleId
      );
      console.log(response["result"]);

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          ObjOperationId.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        }
        else if (operation.OperationName === "Update") {
          ObjOperationId.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          ObjOperationId.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          ObjOperationId.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        DialogShow.value[FieldType] = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }
    return {
      LoadAccountHead,
      ObjOperationId,
      loading,
      EntityIds,
      DialogShow,
      FunctionRights,
      ItemAccountHeadOnChange,
      input,
      Grouping,

      ItemCategoryDropdown,
      LoadItemCategory,
      ItemCategoryOnChange,

      ItemGroupDropdown,
      LoadItemGroup,
      ItemGroupOnChange,

      ItemSubGroupDropdown,
      LoadItemSubGroup,
      ItemSubGroupOnChange,

      BrandDropdown,
      ModelNumberDropdown,
      SizeDropdown,
      ItemConfiguration,
      ItemBrandOnChange,
      ItemModelNumberOnChange,
      ItemSizeOnChange,
      LoadItemConfigurations
    };
  },

  created() { },
});
</script>